import {
  AbstractControl,
  FormArray,
  FormGroup,
  ValidationErrors
} from '@angular/forms';
import { EducationLevel } from '@App/common/enums';

export const EMPLOYMENT_EDUCATION_LEVELS = [
  { id: EducationLevel.None, name: 'None' },
  {
    id: EducationLevel.LessThanHighSchool,
    name: 'Less than High School Diploma'
  },
  { id: EducationLevel.HighSchool, name: 'High School Diploma / GED' },
  { id: EducationLevel.TradeSchool, name: 'Trade School' },
  { id: EducationLevel.SomeCollege, name: 'Some College' },
  { id: EducationLevel.AssociatesDegree, name: 'Associates Degree' },
  { id: EducationLevel.BachelorsDegree, name: 'Bachelors Degree' },
  { id: EducationLevel.MastersDegree, name: 'Masters Degree' },
  { id: EducationLevel.DoctorateDegree, name: 'Doctorate Degree' }
];

export function educationLevelOption(value: unknown): {
  id: number;
  name: string;
} {
  const id =
    value && typeof value === 'object' && 'id' in value
      ? Number((value as { id: number }).id) || 0
      : Number(value) || 0;
  return (
    EMPLOYMENT_EDUCATION_LEVELS.find((item) => item.id === id) ??
    EMPLOYMENT_EDUCATION_LEVELS[0]
  );
}

/**
 * Recursively marks every control in a form group or array as touched and dirty,
 * so validation messages become visible to the user.
 */
export function introTextRequired(
  control: AbstractControl
): ValidationErrors | null {
  const text = String(control.value ?? '')
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  return text ? null : { required: true };
}

export function markAllAsTouched(
  group: FormGroup | FormArray | AbstractControl
): void {
  group.markAsTouched();
  if (group instanceof FormGroup || group instanceof FormArray) {
    Object.values(group.controls).forEach((control) =>
      markAllAsTouched(control)
    );
  }
}

/**
 * Returns only the fields the user actually changed (dirty controls),
 * using the raw value so disabled controls are included when present.
 */
export function getDirtyPayload(form: FormGroup): Record<string, unknown> {
  const payload: Record<string, unknown> = {};
  const raw = form.getRawValue();
  Object.keys(form.controls).forEach((key) => {
    if (form.controls[key].dirty) {
      payload[key] = raw[key];
    }
  });
  return payload;
}
